import cn from 'clsx'
import * as React from 'react'
type Props = any

/**
 * RichTextEditorButton component for rendering button entities in rich text editor
 *
 * A functional component that renders clickable button elements within the Draft.js editor.
 * Extracts button configuration from entity data including caption, link, and target attributes.
 *
 * @param props - Component props including block, theme, and Draft.js entity data
 * @returns JSX element representing a clickable button with configured styling and behavior
 */
const RichTextEditorButton = (props: Props): React.ReactElement<'a'> => {
  const { block, className, theme = {}, ...otherProps } = props
  const {
    blockProps,
    customStyleMap,
    customStyleFn,
    decorator,
    forceSelection,
    offsetKey,
    selection,
    tree,
    contentState,
    blockStyleFn,
    ...elementProps
  } = otherProps
  const combinedClassName = cn(theme.button, className)
  const { caption, link, linkTarget, ...entityProps } = contentState
    .getEntity(block.getEntityAt(0))
    .getData()
  return (
    <a
      className={combinedClassName}
      href={link}
      target={linkTarget}
      {...elementProps}
      {...entityProps}
    >
      {caption}
    </a>
  )
}

export default RichTextEditorButton
